module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 3
// module chunks = 0